import { BusinessLogoAPIService } from "./businessLogo";
import api from "..";

export default new BusinessLogoAPIService(api);
export * from "./types";
